import { z } from "zod";

export const imageFormatSchema = z.object({
  large: z.string(),
  medium: z.string(),
  thumbnail: z.string(),
  x_small: z.string(),
});
